// extracted by mini-css-extract-plugin
module.exports = {"container":"cart-empty_container__tWk9S","title":"cart-empty_title__SjpzM","description":"cart-empty_description__SQh95","links":"cart-empty_links__xOaoi"};